import React from "react";
import styled from "styled-components";
import { HierarchyForm } from "../../Components/Staff/TeamHerarchy/HierarchyForm";
import { TeamStructure } from "../../Components/Staff/TeamHerarchy/TeamStructure";
import { colors } from "../../Shared/colors";
import { decryptData } from "../../services/crypto";

/**
 * Team Hierarchy.
 *
 * The page owns width and vertical rhythm. Previously the two forms sat at
 * 90% while the visualisation and the table below them each set their own
 * max-width of 1400px, so the forms were visibly narrower than everything
 * under them and the gaps between the three blocks were all different.
 */
export const TeamHerarchy = () => {
  let role = null;
  const storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  const canEditStructure = ["ceo", "admin", "hr", "v3", "account"].includes(role);

  return (
    <Main>
      <Inner>
        {canEditStructure ? (
          <Forms>
            <HierarchyForm mode="create" />
            <HierarchyForm mode="update" />
          </Forms>
        ) : null}
        <TeamStructure />
      </Inner>
    </Main>
  );
};

const Main = styled.div`
  background-color: ${colors.inputWhite};
  min-height: calc(100vh - 10vh);
  margin-top: 10vh;
  padding: 1.5rem 0 2.5rem 0;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

/**
 * Two forms side by side, stacking under ~720px. minmax(320px, 1fr) rather
 * than a fixed split so a narrow window gets one full-width column instead of
 * two cramped ones.
 */
const Forms = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1rem;
`;
